<div
  class="inbox-item"
  [class.done]="isDone()"
  [class.inbox-item--overdue]="isOverdue()"
  [class.inbox-item--private]="isPrivateTask()"
    role="button"
    tabindex="0"
    (click)="onItemClick()"
    (keydown)="onItemKeydown($event)">

  <div class="item-leading">
    <div
      class="type-tile"
      [attr.data-intent]="tileIntent()"
      nz-tooltip
      [nzTooltipTitle]="taskTypeLabel()">
      <i nz-icon [nzType]="displayIcon()" class="task-type-icon"></i>
    </div>
    <span class="priority-accent" [attr.data-intent]="priorityIntent()" aria-hidden="true"></span>
  </div>

  <div class="item-content">
    <div class="item-header">
      <div class="item-header__main">
        <h4 class="item-title">{{ item.title }}</h4>

        <div class="item-meta-compact" *ngIf="mobileMetaParts().length > 0">
          <ng-container *ngFor="let part of mobileMetaParts(); let last = last">
            <span class="item-meta-compact__part">{{ part }}</span>
            <span *ngIf="!last" class="item-meta-compact__separator" aria-hidden="true">·</span>
          </ng-container>
        </div>

        <div class="item-badges">
            <span *ngIf="isPrivateTask()" class="meta-pill meta-pill--private" data-intent="neutral">
            <i nz-icon nzType="lock"></i>
            {{ 'activity.inbox.private' | translate }}
          </span>

          <span *ngIf="!isPrivateTask()" class="meta-pill meta-pill--type">
            <i nz-icon [nzType]="displayIcon()"></i>
            {{ taskTypeLabel() }}
          </span>

          <span class="meta-pill" [attr.data-intent]="priorityIntent()">
            <i nz-icon [nzType]="priorityIcon()"></i>
            {{ priorityLabel() }}
          </span>
        </div>
      </div>

      <span *ngIf="item.dueAt" class="date-pill" [attr.data-intent]="isOverdue() ? 'destructive' : 'info'">
        <i nz-icon [nzType]="isOverdue() ? 'warning' : 'calendar'"></i>
        {{ item.dueAt | date : 'dd.MM.yy' }}
      </span>
    </div>

    <p *ngIf="item.description" class="item-description">
      {{ item.description | slice : 0 : 100
      }}<span *ngIf="item.description.length > 100">...</span>
    </p>

    <div class="item-footer">
      <div class="item-meta">
        <span class="status-pill" [attr.data-intent]="statusIntent()">
          <i nz-icon [nzType]="statusIcon()"></i>
          {{ statusLabel() }}
        </span>

        <span class="meta-secondary" *ngIf="isOverdue()">
          <i nz-icon nzType="clock-circle"></i>
          {{ 'activity.inbox.due' | translate }}
        </span>
      </div>

      <button
        nz-button
        nzType="default"
        nzSize="small"
        class="open-btn  desktop-button"
        (click)="onItemClick(); $event.stopPropagation()"
        aria-label="{{ 'notification.navigation.openTask' | translate }}">
        <i nz-icon nzType="arrow-right"></i>
        {{ 'notification.navigation.openTask' | translate }}
      </button>
    </div>
  </div>
</div>
